const body = document.body;
const cursor = document.querySelector(".js-cursor");
const cursorDot = document.querySelector(".js-cursorDot");

export function addCursorTextClass(text) {
  cursor.classList.add("cursor--text");
  cursorDot.dataset.label = text;
}

export function removeCursorTextClass() {
  cursor.classList.remove("cursor--text");
  cursorDot.dataset.label = "";
}

export default function () {
  // const ctas = document.querySelectorAll(".btn");
  const cursorTriggers = document.querySelectorAll(".js-cursorText");

  // Dot follows cursor
  body.addEventListener("mousemove", function (e) {
    cursorDot.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
  });

  // Expand dot on cta hover
  // ctas.forEach(function (cta) {
  //  cta.addEventListener("mouseenter", function () {
  //    cursor.classList.add("cursor--cta");
  //  });
  //  cta.addEventListener("mouseleave", function () {
  //    cursor.classList.remove("cursor--cta");
  //  });
  // });

  cursorTriggers.forEach(function (t) {
    const hoverText = t.dataset.label;
    t.addEventListener("mouseenter", function () {
      addCursorTextClass(hoverText);
    });
    t.addEventListener("mouseleave", function () {
      removeCursorTextClass();
    });
  });
}
